export const pageQuery = `query Page($query: JSON!) {
  entries(query: $query) {
    limit
    skip
    sys
    total
    items {
      ...PageFragment
    }
  }
}

fragment PageFragment on Entry {
  fields {
    __typename
    ... on EntryPage {
      header {
        fields {
          title
          mixedList {
            fields {
              __typename
              ... on LinkItem {
                title
                url
                slug
                media {
                  fields {
                    __typename
                    ... on ImageWrapper {
                      title
                      description {
                        content {
                          content {
                            value
                          }
                        }
                      }
                      altText
                      image {
                        fields {
                          file {
                            fileName
                            contentType
                            url
                            details {
                              size
                              image {
                                height
                                width
                              }
                            }
                          }
                        }
                      }
                    }
                    ... on IconWrapper {
                      title
                      icon {
                        fields {
                          file {
                            fileName
                            contentType
                            url
                            details {
                              size
                              image {
                                height
                                width
                              }
                            }
                          }
                        }
                      }
                      url
                    }
                  }
                }
              }
              ... on CTA {
                label
                url
                target
              }
              ... on Nav {
                title
                list {
                  fields {
                    title
                    url
                    slug
                    description
                    media {
                      fields {
                        __typename
                        ... on ImageWrapper {
                          title
                          description {
                            content {
                              content {
                                value
                              }
                            }
                          }
                          altText
                          image {
                            fields {
                              file {
                                fileName
                                contentType
                                url
                                details {
                                  size
                                  image {
                                    height
                                    width
                                  }
                                }
                              }
                            }
                          }
                        }
                        ... on IconWrapper {
                          title
                          icon {
                            fields {
                              file {
                                fileName
                                contentType
                                url
                                details {
                                  size
                                  image {
                                    height
                                    width
                                  }
                                }
                              }
                            }
                          }
                          url
                        }
                      }
                    }
                    navMenu {
                      fields {
                        title
                        url
                        slug
                        description
                        media {
                          fields {
                            __typename
                            ... on ImageWrapper {
                              title
                              altText
                              image {
                                fields {
                                  file {
                                    fileName
                                    contentType
                                    url
                                    details {
                                      size
                                      image {
                                        height
                                        width
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ... on IconWrapper {
                              title
                              icon {
                                fields {
                                  file {
                                    fileName
                                    contentType
                                    url
                                    details {
                                      size
                                      image {
                                        height
                                        width
                                      }
                                    }
                                  }
                                }
                              }
                              url
                            }
                          }
                        }
                        navMenu {
                          fields {
                            title
                            url
                            slug
                            list {
                              fields {
                                title
                                show
                              }
                            }
                            media {
                              fields {
                                __typename
                                ... on ImageWrapper {
                                  title
                                  altText
                                  image {
                                    fields {
                                      file {
                                        fileName
                                        contentType
                                        url
                                        details {
                                          size
                                          image {
                                            height
                                            width
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                                ... on IconWrapper {
                                  title
                                  icon {
                                    fields {
                                      file {
                                        fileName
                                        contentType
                                        url
                                        details {
                                          size
                                          image {
                                            height
                                            width
                                          }
                                        }
                                      }
                                    }
                                  }
                                  url
                                }
                              }
                            }
                          }
                        }
                        cta {
                          fields {
                            label
                            target
                            url
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      seo {
        fields {
          urlSlug
          titleTag
          metaDescription
          metaRobotsIndex
          crawlerFollow
          keywords
        }
      }
      sections {
        fields {
          title
          description {
            content {
              content {
                data
                content
                value
              }
            }
          }
          list {
            fields {
              title
              description {
                content {
                  content {
                    value
                  }
                }
              }
              media {
                fields {
                  __typename
                  ... on ImageWrapper {
                    title
                    altText
                    image {
                      fields {
                        file {
                          fileName
                          contentType
                          url
                          details {
                            size
                            image {
                              height
                              width
                            }
                          }
                        }
                      }
                    }
                  }
                  ... on IconWrapper {
                    title
                    icon {
                      fields {
                        file {
                          fileName
                          contentType
                          url
                          details {
                            size
                            image {
                              height
                              width
                            }
                          }
                        }
                      }
                    }
                    url
                  }
                }
              }
              show
              reference {
                fields {
                  __typename
                  ... on LinkItem {
                    title
                    url
                    slug
                    media {
                      fields {
                        __typename
                        ... on ImageWrapper {
                          title
                          altText
                          image {
                            fields {
                              file {
                                fileName
                                contentType
                                url
                                details {
                                  size
                                  image {
                                    height
                                    width
                                  }
                                }
                              }
                            }
                          }
                        }
                        ... on IconWrapper {
                          title
                          icon {
                            fields {
                              file {
                                fileName
                                contentType
                                url
                                details {
                                  size
                                  image {
                                    height
                                    width
                                  }
                                }
                              }
                            }
                          }
                          url
                        }
                      }
                    }
                  }
                  ... on CTA {
                    label
                    url
                    target
                  }
                }
              }
            }
          }
        }
      }
      footer {
        fields {
          mixedList {
            fields {
              __typename
              ... on LinkItem {
                title
                url
                slug
                media {
                  fields {
                    __typename
                    ... on ImageWrapper {
                      title
                      altText
                      image {
                        fields {
                          file {
                            fileName
                            contentType
                            url
                            details {
                              size
                              image {
                                height
                                width
                              }
                            }
                          }
                        }
                      }
                    }
                    ... on IconWrapper {
                      title
                      icon {
                        fields {
                          file {
                            fileName
                            contentType
                            url
                            details {
                              size
                              image {
                                height
                                width
                              }
                            }
                          }
                        }
                      }
                      url
                    }
                  }
                }
              }
              ... on CTA {
                label
                url
                target
              }
              ... on Nav {
                title
                list {
                  fields {
                    title
                    url
                    slug
                    media {
                      fields {
                        __typename
                        ... on ImageWrapper {
                          title
                          altText
                          image {
                            fields {
                              file {
                                fileName
                                contentType
                                url
                                details {
                                  size
                                  image {
                                    height
                                    width
                                  }
                                }
                              }
                            }
                          }
                        }
                        ... on IconWrapper {
                          title
                          icon {
                            fields {
                              file {
                                fileName
                                contentType
                                url
                                details {
                                  size
                                  image {
                                    height
                                    width
                                  }
                                }
                              }
                            }
                          }
                          url
                        }
                      }
                    }
                    navMenu {
                      fields {
                        title
                        url
                        slug
                        media {
                          fields {
                            __typename
                            ... on ImageWrapper {
                              title
                              altText
                              image {
                                fields {
                                  file {
                                    fileName
                                    contentType
                                    url
                                    details {
                                      size
                                      image {
                                        height
                                        width
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            ... on IconWrapper {
                              title
                              icon {
                                fields {
                                  file {
                                    fileName
                                    contentType
                                    url
                                    details {
                                      size
                                      image {
                                        height
                                        width
                                      }
                                    }
                                  }
                                }
                              }
                              url
                            }
                          }
                        }
                        navMenu {
                          fields {
                            title
                            url
                            slug
                            media {
                              fields {
                                __typename
                                ... on ImageWrapper {
                                  title
                                  altText
                                  image {
                                    fields {
                                      file {
                                        fileName
                                        contentType
                                        url
                                        details {
                                          size
                                          image {
                                            height
                                            width
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                                ... on IconWrapper {
                                  title
                                  icon {
                                    fields {
                                      file {
                                        fileName
                                        contentType
                                        url
                                        details {
                                          size
                                          image {
                                            height
                                            width
                                          }
                                        }
                                      }
                                    }
                                  }
                                  url
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

export const variable = ({ contentType, tag }: { contentType: string; tag?: string }) => ({
  query: {
    content_type: contentType,
    'metadata.tags.sys.id[in]': tag,
    include: 8,
  },
});
